import React, { useEffect, useState } from 'react';
import './index.css';
import ScreenTabs from './components/ScreenTabs';
import Preloader from './pages/Preloader';
import Splash from './pages/Splash';
import Onboarding from './pages/Onboarding';
import Login from './pages/Login';
import Home from './pages/Home';
import Ticket from './pages/Ticket';
import Notifications from './pages/Notifications';
import EventDetails from './pages/EventDetails';

const screens = ['Splash', 'Onboarding', 'Login', 'Home', 'Ticket', 'Notifications', 'EventDetails'];

const screenFromHash = () => {
  const hash = window.location.hash.replace('#', '').toLowerCase();
  return screens.find((screen) => screen.toLowerCase() === hash) || 'Splash';
};

export default function App() {
  const [activeScreen, setActiveScreen] = useState(screenFromHash);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loaderTimer = window.setTimeout(() => setIsLoading(false), 2600);
    return () => window.clearTimeout(loaderTimer);
  }, []);

  useEffect(() => {
    const handleHashChange = () => setActiveScreen(screenFromHash());
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const changeScreen = (screen) => {
    window.location.hash = screen.toLowerCase();
    setActiveScreen(screen);
  };

  const goNext = () => {
    const index = screens.indexOf(activeScreen);
    changeScreen(screens[(index + 1) % screens.length]);
  };

  return (
    <main className="app-shell">
      <div className="phone-frame">
        {isLoading && <Preloader />}
        {!isLoading && activeScreen === 'Splash' && <Splash goNext={goNext} />}
        {!isLoading && activeScreen === 'Onboarding' && <Onboarding goNext={goNext} />}
        {!isLoading && activeScreen === 'Login' && <Login goNext={goNext} />}
        {!isLoading && activeScreen === 'Home' && <Home activeScreen={activeScreen} onNavigate={changeScreen} />}
        {!isLoading && activeScreen === 'Ticket' && <Ticket activeScreen={activeScreen} onNavigate={changeScreen} />}
        {!isLoading && activeScreen === 'Notifications' && <Notifications activeScreen={activeScreen} onNavigate={changeScreen} />}
        {!isLoading && activeScreen === 'EventDetails' && <EventDetails activeScreen={activeScreen} onNavigate={changeScreen} />}
      </div>
      {!isLoading && <ScreenTabs screens={screens} activeScreen={activeScreen} onChange={changeScreen} />}
    </main>
  );
}
